import { render, staticRenderFns } from "./SideBarTitle.vue?vue&type=template&id=a6e50e60&scoped=true"
import script from "./SideBarTitle.vue?vue&type=script&lang=js"
export * from "./SideBarTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e50e60",
  null
  
)

export default component.exports